/**图片回复的字段 */
import { BaseModel } from '../BaseModel';

export  class WxImg extends BaseModel{ 
    ImageId:number=0 
        Type:number=1
        JumpLink:string=""
        UploadImage:string=""
        Keyword:string=""
        State:number=1
        Nature:number=0
        MediaId:string=""     
}